import axios from "axios";
import { useAuth } from "./auth.service";

const API_BASE_URL = process.env.REACT_APP_BACKEND_API;

export const useStatisticsService = () => {
  const { user } = useAuth();

  const getAuthHeaders = () => ({
    "Content-Type": "application/json",
    "x-access-token": user?.accessToken,
  });

  const getMessageStatistics = async (period = "month", startDate, endDate) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/contacts/statistics?period=${period}&start_date=${startDate}&end_date=${endDate}`,
        { headers: getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching message statistics:", error);
      throw error;
    }
  };

  const getAutomationReport = async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      Object.keys(filters).forEach(key => {
        if (filters[key] !== null && filters[key] !== undefined && filters[key] !== "") {
          params.append(key, filters[key]);
        }
      });
      const response = await axios.get(
        `${API_BASE_URL}/renovaciones/automatizaciones/report?${params.toString()}`,
        { headers: getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching automation report:", error);
      throw error;
    }
  };

  const getAutomations = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/renovaciones/automatizaciones`,
        { headers: getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching automations:", error);
      throw error;
    }
  };

  const getAutomationAudits = async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      Object.keys(filters).forEach(key => {
        if (filters[key] !== null && filters[key] !== undefined && filters[key] !== "") {
          params.append(key, filters[key]);
        }
      });
      const response = await axios.get(
        `${API_BASE_URL}/renovaciones/automatizaciones/audits?${params.toString()}`,
        { headers: getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching automation audits:", error);
      throw error;
    }
  };

  return { getMessageStatistics, getAutomationReport, getAutomations, getAutomationAudits };
};
